<template>
    <div id="relatorio-extrato">
        <div class="title d-flex justify-content-center mb-5">
            <h2>Relatório Extrato</h2>
        </div>
        <!-- Tabela Totais -->
        <div class="">
            <div class="row">
                <div class="mb-3 d-flex justify-content-between mx-3 w-100 align-items-center">
                    <span class=""><strong> Período: </strong> {{ periodo.startDate | formatData }} à {{ periodo.endDate | formatData }}</span>
                    <strong style="font-size: 1rem; font-weight: 600;"> {{companyName}} </strong>
                </div>
            </div>
            <div class="row col-5 mt-3">
                <table class="table table-borderless table-sm tabela-totais">
                    <thead>
                        <tr class="border border-dark">
                            <th scope="col" 
                            class="span-header text-center border border-dark">Saldo Inicial</th>
                            <th scope="col" class="span-header text-center border border-dark">Entradas</th>
                            <th scope="col" class="span-header text-center border border-dark">Saídas</th>
                            <th scope="col" class="span-header text-center border border-dark">Saldo Final</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border border-dark" v-if="this.dados && this.dados.totais">
                            <th scope="row" class="text-center border border-dark">
                                R$<strong> {{ this.dados.totais.saldoInicial | formatValue(2,true) }} </strong>
                            </th>
                            <th scope="row" class="text-center border border-dark">
                                R$<strong> {{ this.dados.totais.totalRecebimentos | formatValue(2,true) }} </strong>
                            </th>
                            <th scope="row" class="text-center border border-dark">
                                R$<strong> {{ this.dados.totais.totalPagamentos | formatValue(2,true) }} </strong>
                            </th>
                            <th scope="row" class="text-center border border-dark">
                                R$<strong> {{ this.dados.totais.saldoFinal | formatValue(2,true) }} </strong>
                            </th>                             
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        <hr class="mt-2">

        <!-- Tabela Contas -->
        <div class="row">
            <div class="col-3">
                <table class="table table-borderless table-sm tabela-totais" v-if="this.dados && this.dados.contas">
                    <div class="w-100 text-center"> 
                        <h1 class="" style="font-size: 1.2rem; font-weight: 600; color: #000">Saldo Por Conta</h1>
                    </div>
                    <template v-for="(conta, index) in dados.contas">
                        <!-- <thead  >
                            <tr class="text-center">
                                <th scope="col" colspan="2" class="span-header py-3"><span style="font-size:1rem" ></span></th>
                            </tr>
                        </thead> -->
                        <tbody >
                            <tr class="border border-dark">
                                <th scope="row" class="text-center border border-dark" > <span style="font-weight: 400"> {{ conta.conta }} </span></th>
                                <td class="text-center border border-dark"> <span style="font-weight: 500"> R$ {{ conta.saldo | formatValue(2,true) }} </span> </td>
                            </tr>
                        </tbody>
                    </template>
                </table>
            </div>
        </div>
        
        <hr class="mt-2">

        <!-- Tabela Titulos -->
        <div class="d-flex justify-content-center">
            <table class="table table-borderless table-sm tabela-titulos">
                <thead>
                    <tr class="border-bottom border-dark">
                        <th scope="col" class="span-header">Documento</th>
                        <th scope="col" class="span-header text-center">Data</th>
                        <th scope="col" class="span-header text-center">Natureza</th>
                        <th scope="col" class="span-header text-center">Cliente/Fornecedor</th>
                        <th scope="col" class="span-header text-center">Tipo</th>
                        <th scope="col" class="span-header text-center">Valor</th>
                        <th scope="col" class="span-header text-center">Saldo</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(fin, index) in finList">
                        <tr class="border-bottom border-dark" v-if="fin.codpart && !fin.codfin" :key="index">
                            <th scope="row" colspan="6"><span class="span-title font-weight-bold">{{ fin.nome }}</span></th>
                        </tr>
                        <tr class="border-bottom border-dark" v-if="fin.codfin" :key="index">
                            <th scope="row">{{ fin.doc }} / {{ fin.parcela }}</th>
                            <td class="text-center">{{ fin.data | formatData }}</td>
                            <td class="text-center">{{ fin.natureza }}</td>
                            <td class="text-center">{{ fin.nome }}</td>
                            <td class="text-center" v-if="fin.tipo == 'R' || fin.tipo == 'E'">Recebimento</td>
                            <td class="text-center" v-if="fin.tipo == 'P' || fin.tipo == 'S'">Pagamento</td>
                            <td class="text-center">{{ fin.vlr | formatValue(2, true) }}</td>                                
                            <td class="text-center">{{ fin.saldo | formatValue(2, true) }}</td>                                
                        </tr>
                        <tr  v-if="fin.total" :key="index">
                            <th scope="row" colspan="5" class="span-header text-right font-weight-bold">Total: </th>
                            <th scope="row" colspan="6" class="span-header text-right font-weight-bold">R$ {{ fin.total | formatValue(2)}}</th>
                        </tr>
                        <tr  v-if="fin.totalGeral" :key="index">
                            <th scope="row" colspan="5" class="span-header text-right font-weight-bold">Total Geral: </th>
                            <th scope="row" colspan="6" class="span-header text-right font-weight-bold">R$ {{ fin.totalGeral | formatValue(2)}}</th>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'companyName','periodo', 'dados', 'finList' ],

    methods: {
        handleAfterPrint(window){

            window.addEventListener('afterprint', () => {
                window.close();
            })

        },
        relatorio (prtHtml) {

            // const prtHtml = document.getElementById('relatorio').innerHTML

            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
            }
            const WinPrint = window.open('', '_blank' );

            WinPrint.document.write(`
                <!DOCTYPE html>
                <html>
                    <head>
                        ${stylesHtml}
                    </head>
                    <body>
                        <div>
                            <div class="w-100 p-3">
                                ${prtHtml}
                            </div>
                        </div>
                    </body>
                </html>
            `);

            WinPrint.document.close();

            WinPrint.focus();

            this.handleAfterPrint(WinPrint);
            // WinPrint.print();
            // WinPrint.close();
            
            this.$emit('close');
        },
    },

    mounted () {
        let vm = this
        setTimeout(() => {
            const prtHtml = document.getElementById('relatorio-extrato').innerHTML
            vm.relatorio(prtHtml)
        }, 1000);
    },

    created () {

    },

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/forms/financeiro-relatorio-extrato.vue